export const LIST_ROW_HEIGHT_WITH_GAP = 38;
export const MAX_DISPLAYING_ROW_MOBILE = 10;
